<template>
  <div class="aboutUs_main">
    <div class="page-banner">
      <img :src="subBannerImgurl" alt />
    </div>
    <div class="aboutUs_body">
      <div class="tab_list animate__animated animate__fadeInUp">
        <img src="../assets/pcImg/company/tabbg.png" alt class="tab_img" />
        <div class="all_c">
          <div class="intro_" @click="myTab(0)">
            <img src="../assets/pcImg/company/intro_.png" v-if="tab==0" alt />
            <img src="../assets/pcImg/company/intro.png" v-else alt />
            公司简介
          </div>
          <div class="history_" @click="myTab(1)">
            <img src="../assets/pcImg/company/history_.png" v-if="tab==1" alt />
            <img src="../assets/pcImg/company/history.png" v-else alt />
            公司历程
          </div>
        </div>

        <!-- <div class="team_" @click="myTab(2)">
                    <img src="../assets/pcImg/company/team_.png" v-if="tab==2" alt />
                    <img src="../assets/pcImg/company/team.png" v-else alt />
                    团队建设
        </div>-->

        <div class="light_line" :class="tab==1?'two_line':''||tab==2?'three_line':''"></div>
      </div>
      <company-intro v-if="tab==0"></company-intro>
      <company-history v-if="tab==1"></company-history>
      <!-- <company-team v-if="tab==2"></company-team> -->
    </div>
    <loading v-if="loading" class="loading"></loading>
  </div>
</template>
<script>
import Loading from './loading'
import CompanyIntro from './CompanyIntroduce'
import CompanyHistory from './CompanyHistory'
import CompanyTeam from './CompanyTeam'
export default {
  components: { Loading, CompanyIntro, CompanyHistory },
  data() {
    return {
      tab: 0,
      subBannerImgurl: '',
      loading: true,
    }
  },
  mounted: function () {
    this.getSubBannerImgurl()
  },
  methods: {
    myTab: function (e) {
      this.tab = e
    },
    getSubBannerImgurl: function () {
      let datas = {
        position: 3,
      }
      this.getHttp(this, datas, '/front/page/banner', function (obj, data) {
        if (data.status == 2000) {
          if (data.data.length !== 0) {
            obj.subBannerImgurl = data.data[0].img_url
            console.log('此时的图片有值吗', data.data[0].img_url)
          }
        }
        obj.loading = false
      })
    },
  },
  computed: {
    getUserLangs() {
      return this.$i18n.locale
    },
  },
  watch: {
    getUserLangs(val) {},
  },
}
</script>
<style lang="scss" scoped>
.page-banner {
  width: 100%;
  height: 0;
  padding-bottom: 32.38%;
  position: relative;
  background: #202630;
}
.aboutUs_main {
  background: #1d222c !important;
}
.page-banner img {
  width: 100%;
}
.aboutUs_body {
  position: relative;
  width: 100%;
  overflow-x: hidden;
  .tab_list {
    width: 100%;
    height: 0.79rem;
    position: relative;
    z-index: 2;
    .tab_img {
      width: 100%;
      height: 100%;
      display: block;
    }
    .all_c {
      width: 8rem;
      position: absolute;
      left: 50%;
      top: 0;
      margin-left: -4rem;
      height: 0.83rem;
    }
    .intro_,
    .history_,
    .team_ {
      width: 50%;
      height: 0.83rem;
      line-height: 0.83rem;
      font-size: 0.22rem;
      color: white;
      position: absolute;
      left: 50%;
      top: 0;
      text-align: center;
      cursor: pointer;
    }
    .intro_ {
      left: 0;
      img {
        width: 0.26rem;
        margin-right: 0.05rem;
      }
    }
    .history_ {
      right: 0;
      img {
        width: 0.41rem;
        margin-right: 0.05rem;
      }
    }
    .team_ {
      margin-left: 2rem;
      img {
        width: 0.26rem;
        margin-right: 0.05rem;
      }
    }
    .light_line {
      width: 2.01rem;
      height: 0.03rem;
      background-color: chocolate;
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -2.99rem;
      border-radius: 1.5px;
      transition: margin-left 0.5s ease;
    }
    .two_line {
      margin-left: 1.01rem;
    }
    .three_line {
      margin-left: 3.35rem;
    }
  }
}
</style>